<template>
  <div>
    <p>These indicators will help you determine if this lead may be more motivated to sell.</p>

    <div class="columns is-multiline my-100">
      <hot-motivator-item label="Vacant?" :value="motivatorData.vacant"/>
      <hot-motivator-item label="Death?" :value="motivatorData.death"/>
      <hot-motivator-item label="Lien?" :value="motivatorData.lien"/>
      <hot-motivator-item label="MLS Cancelled?" :value="motivatorData.mlsCancelled"/>
      <hot-motivator-item label="Spousal Death?" :value="motivatorData.spousalDeath"/>
      <hot-motivator-item label="Tax Lien?" :value="motivatorData.taxLien"/>
      <hot-motivator-item label="MLS Failed?" :value="motivatorData.mlsFailed"/>
      <hot-motivator-item label="Death Transfer?" :value="motivatorData.deathTransfer"/>
      <hot-motivator-item label="Deed In Lieu?" :value="motivatorData.deedInLieu"/>
      <hot-motivator-item label="Adjustable Rate?" :value="motivatorData.adjustableRate"/>
      <hot-motivator-item label="Inherited?" :value="motivatorData.inherited"/>
      <hot-motivator-item label="Warranty Deed?" :value="motivatorData.warrantyDeed"/>
      <hot-motivator-item label="Pre Foreclosure?" :value="motivatorData.preForeclosure"/>
      <hot-motivator-item label="Trustee Sale?" :value="motivatorData.trusteeSale"/>
      <hot-motivator-item label="Quit Claim?" :value="motivatorData.quitClaim"/>
    </div>
  </div>
</template>

<script>
import HotMotivatorItem from "./components/HotMotivatorItem.vue";
import utils from "../../services/utils";

export default {
  name: "HotMotivatorModal",
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  components: {HotMotivatorItem},
  computed: {
    motivatorData() {
      return utils.getHotMotivatorsFromRealPropertyData(this.property)
    }
  },
}
</script>
